import Popup from "reactjs-popup";

import { Link } from "react-router-dom";

import genericPlayer from "img/generic-player.svg";

function App({
  id,
  name,
  canEdit,
  teamId,
  width = "195px",
  height = "205px",
  addPlayerOrStaffLink,
  isStaff = false
}) {
  return (
    <div
      style={{ width: width, height: height }}
      className="team-member-detail"
    >
      {addPlayerOrStaffLink && (
        <Link to={addPlayerOrStaffLink}>
          <div
            style={{
              display: "flex",
              textAlign: "center",
              height: "175px",
            }}
          >
            <div style={{ margin: "auto" }}>
              <i className="fa fa-plus circled-icon fa-3x"></i>
            </div>
          </div>
        </Link>
      )}

      {!addPlayerOrStaffLink && (
        <div style={{ position: "relative", textAlign: "center" }}>
          <img
            className="team-member-image"
            alt="personImage"
            src={`${genericPlayer}`}
          ></img>
        </div>
      )}

      <div className="label team-member-text">
        <span className="team-member-name">
          {name}{" "}
          {id && ( // if id it means we are selecting ourselves and shouldn't allow edit
            <Popup
              trigger={<i className="fa fa-ellipsis-v"></i>}
              position="left center"
            >
              <div className="dropdown-content">
                <Link className="dropdown-item" to={isStaff ? `/staff/${id}` : `/jogadores/${id}` }>
                  Detalhe
                </Link>
                {canEdit && (
                  <Link
                    className="dropdown-item"
                    to={`/equipa/${teamId}/jogadores/${id}/apagar`}
                  >
                    Remover da equipa
                  </Link>
                )}
              </div>
            </Popup>
          )}
        </span>
      </div>
    </div>
  );
}

export default App;
